<template>
  <span :class="numClass">
    {{ displayedNumber }}
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    targetNumber: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      default: 1000 // 2 seconds
    },
    numClass: {
      required: false,
      default: ''
    }
  },
  data() {
    return {
      displayedNumber: 0,
      animationFrame: null
    }
  },
  mounted() {
    this.startAnimation()
  },
  methods: {
    startAnimation() {
      const startTime = performance.now()
      const animate = currentTime => {
        const elapsedTime = currentTime - startTime
        const progress = Math.min(elapsedTime / this.duration, 1)
        this.displayedNumber = Math.floor(this.targetNumber * progress)

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(animate)
        } else {
          this.displayedNumber = this.targetNumber
        }
      }
      requestAnimationFrame(animate)
    }
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
  },
  components: {}
}
</script>

<style scoped lang="scss">
.counter {
  position: relative;
  height: 1em;
  overflow: hidden;
}

.counter::before {
  content: attr(data-count);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  opacity: 0;
  animation: countUp 1s ease-out forwards;
}

@keyframes countUp {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
